module.exports = __webpack_public_path__ + "mainassets/img/gallery-arrow-right.1a01f6c2.svg";